import { EProductTourTargets } from '@constants';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { WidgetTitle, WidgetWrapper } from '../shared/WidgetShared.styles';

import { EmptyQuizzes } from './components/EmptyQuizzes';
import { RenderQuizResults } from './components/RenderQuizResults';
import { Wrapper, TitleWrapper, ButtonsWrapper } from './QuizModeWidget.styles';

import { CreateQuizWithNoCourseModal } from '@/components/CreateQuizWithNoCourseModal';
import { LoadingCircleSpinner } from '@/components/Loaders';
import { useIsMobile } from '@/hooks';
import { useMyQuizResultList, useCreateQuizWithNoCourseModalStore } from '@/store';

export const QuizModeWidget: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const navigateTo = useNavigate();
  const { quizResults, isLoading } = useMyQuizResultList();
  const { setIsOpen } = useCreateQuizWithNoCourseModalStore();
  const isMobile = useIsMobile();

  const thereAreMoreThanThreeQuizzes = quizResults?.length > 3;

  const handleNavigateToQuizzes = () => {
    navigateTo('/tests/history');
  };

  const handleNewTest = () => {
    setIsOpen(true);
  };

  return (
    <>
      <WidgetWrapper id={EProductTourTargets.QUIZ_MODE_WIDGET}>
        <TitleWrapper>
          <WidgetTitle>{t('QUIZZES')}</WidgetTitle>
          <ButtonsWrapper>
            {thereAreMoreThanThreeQuizzes && !isMobile && (
              <Button type="text" onClick={handleNavigateToQuizzes}>
                {t('GO_TO_HISTORY')}
              </Button>
            )}
            <Button onClick={handleNewTest}>{t('NEW_TEST')}</Button>
          </ButtonsWrapper>
        </TitleWrapper>
        {isLoading ? (
          <LoadingCircleSpinner />
        ) : (
          <Wrapper>{quizResults?.length > 0 ? <RenderQuizResults /> : <EmptyQuizzes />}</Wrapper>
        )}
      </WidgetWrapper>
      <CreateQuizWithNoCourseModal />
    </>
  );
};
